import React, { ReactNode } from 'react';
import { AppBar, Container } from '@mui/material';
import Grid from '@mui/material/Grid';
import { SvgInsightsLogo } from '@insights-ltd/design-library/components';

type HeaderLayoutProps = {
  children: ReactNode;
};

const HeaderLayout = ({ children }: HeaderLayoutProps) => {
  return (
    <AppBar
      position="static"
      elevation={0}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.info.dark}`,
      })}
    >
      <Container maxWidth="lg">
        <Grid
          container
          sx={(theme) => ({
            alignItems: 'center',
            padding: `${theme.spacing(2)} 0`,
            '& > svg': {
              fill: theme.palette.blue.main,
              width: '8rem',
              height: '2.125rem',
            },
          })}
        >
          <SvgInsightsLogo />
          <Grid size="grow">{children}</Grid>
        </Grid>
      </Container>
    </AppBar>
  );
};

export default HeaderLayout;
